// import React from "react";
// import { Card, CardContent, Alert, Stack, Paper, Grid, Typography } from "@mui/material";

// const EmailLogsTab = ({ logs }) => {
//   return (
//     <Card variant="outlined" sx={{ borderRadius: 3 }}>
//       <CardContent>
//         {logs.length === 0 ? (
//           <Alert severity="info">No email logs found yet.</Alert>
//         ) : (
//           <Stack spacing={2}>
//             {logs.map((log) => (
//               <Paper key={log.id} variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={4}>
//                     <Typography variant="subtitle2">Recipient</Typography>
//                     <Typography variant="body2">{log.customer_email}</Typography>
//                   </Grid>
//                   <Grid item xs={12} md={3}>
//                     <Typography variant="subtitle2">Sent At</Typography>
//                     <Typography variant="body2">{log.sent_at || "-"}</Typography>
//                   </Grid>
//                   <Grid item xs={12} md={2}>
//                     <Typography variant="subtitle2">Open Count</Typography>
//                     <Typography variant="body2">{log.open_count ?? 0}</Typography>
//                   </Grid>
//                   <Grid item xs={12} md={3}>
//                     <Typography variant="subtitle2">Last Opened</Typography>
//                     <Typography variant="body2">{log.last_opened_at || "Not opened"}</Typography>
//                   </Grid>
//                 </Grid>
//               </Paper>
//             ))}
//           </Stack>
//         )}
//       </CardContent>
//     </Card>
//   );
// };

// export default EmailLogsTab;

import React from "react";
import {
  Card, CardContent, Alert, Stack, Paper, Grid, Typography, Box, Chip, Tooltip
} from "@mui/material";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const EmailLogsTab = ({ logs }) => {
  if (logs.length === 0) {
    return (
      <Paper elevation={0} sx={{ p: 6, textAlign: "center", borderRadius: 3, border: "1px dashed #c5cae9" }}>
        <InboxOutlinedIcon sx={{ fontSize: 56, color: "#c5cae9", mb: 2 }} />
        <Typography variant="h6" fontWeight={600} color="text.secondary">No Email Logs Yet</Typography>
        <Typography variant="body2" color="text.secondary">Sent emails will appear here with tracking info.</Typography>
      </Paper>
    );
  }

  return (
    <Stack spacing={2}>
      {/* Summary */}
      <Stack direction="row" spacing={2} sx={{ mb: 1, flexWrap: "wrap" }} useFlexGap>
        <Chip icon={<MarkEmailReadOutlinedIcon />} label={`${logs.length} Total Sent`}
          sx={{ backgroundColor: accentLight, color: accent, fontWeight: 600 }} />
        <Chip icon={<VisibilityOutlinedIcon />} label={`${logs.filter(l => l.open_count > 0).length} Opened`}
          sx={{ backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
      </Stack>

      {logs.map((log) => (
        <Paper key={log.id} elevation={0}
          sx={{
            p: 2.5, borderRadius: 3, border: "1px solid #e3e8f0",
            transition: "all 0.2s", "&:hover": { borderColor: accent, boxShadow: "0 4px 16px rgba(13,71,161,0.08)" }
          }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, backgroundColor: accentLight, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <MarkEmailReadOutlinedIcon sx={{ color: accent, fontSize: 20 }} />
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={600} sx={{ color: "#1a1a2e" }}>{log.customer_email}</Typography>
                  <Typography variant="caption" color="text.secondary">Recipient</Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid item xs={6} md={3}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <AccessTimeOutlinedIcon sx={{ fontSize: 16, color: "#999" }} />
                <Box>
                  <Typography variant="body2" fontWeight={500}>{log.sent_at ? new Date(log.sent_at).toLocaleString() : "-"}</Typography>
                  <Typography variant="caption" color="text.secondary">Sent At</Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid item xs={3} md={2}>
              <Tooltip title="Times opened">
                <Chip size="small"
                  icon={<VisibilityOutlinedIcon sx={{ fontSize: 16 }} />}
                  label={log.open_count ?? 0}
                  sx={{
                    fontWeight: 700, fontSize: 13,
                    backgroundColor: (log.open_count ?? 0) > 0 ? "#e8f5e9" : "#f5f5f5",
                    color: (log.open_count ?? 0) > 0 ? "#2e7d32" : "#999",
                  }} />
              </Tooltip>
            </Grid>

            <Grid item xs={3} md={3}>
              <Typography variant="body2" fontWeight={500}>{log.last_opened_at ? new Date(log.last_opened_at).toLocaleString() : "Not opened"}</Typography>
              <Typography variant="caption" color="text.secondary">Last Opened</Typography>
            </Grid>
          </Grid>
        </Paper>
      ))}
    </Stack>
  );
};

export default EmailLogsTab;
